export interface RippleDropDetail {
  /** Posição X em coordenadas de viewport (0–1, esquerda → direita). */
  x: number;
  /** Posição Y em coordenadas de viewport (0–1, baixo → cima). */
  y: number;
  /** Intensidade do drop (0–1). */
  strength?: number;
}

const EVENT_NAME = 'portfolio:ripple';

export function dispatchRipple(clientX: number, clientY: number, strength = 0.6) {
  const x = clientX / window.innerWidth;
  const y = 1 - clientY / window.innerHeight;
  window.dispatchEvent(
    new CustomEvent<RippleDropDetail>(EVENT_NAME, { detail: { x, y, strength } }),
  );
}

export function onRipple(handler: (detail: RippleDropDetail) => void) {
  const listener = (event: Event) => {
    const ce = event as CustomEvent<RippleDropDetail>;
    handler(ce.detail);
  };
  window.addEventListener(EVENT_NAME, listener);
  return () => window.removeEventListener(EVENT_NAME, listener);
}
